<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub2}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left">
      <div class="form-group">
        <!-- <label class="col-sm-5 col-form-label font18 px-0">Age of Company</label> -->
        <div class="col-sm-12" id="commercial">
          <ng-select [items]="options"
          placeholder="Select"
          [searchable]="false" [clearable]="false"
          (change)="getAge(company_age);" [(ngModel)]="company_age">
          </ng-select>
          <!-- <select (change)="getAge($event);" [(ngModel)]="company_age" class="dropdown-toggle form-control">
            <option *ngFor="let option of options" value={{option}}>{{option}}</option>
          </select> -->
        </div>
      </div>
    </div>
    <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'combtn': user_bot}"
      (click)="next();">Next</button>
    <div class="mt-5" >
      <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">JUST AN FYI</p>
        <p class="text-center tipmes">{{questionObj.tip}}</p>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-0 px-0" [attr.id]="questionObj._id" style="float:left;">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="col-12 pl-0">
    <div class="form-group col-9 px-0 mt-2 pull-right" style="margin-bottom:6px !important">
      <!-- <label class="col-5 col-form-label text-right">Age of Company</label> -->
      <div class="col-sm-12 px-0" id="commercial">
        <ng-select [items]="options"
        placeholder="Select"
        [searchable]="false" [clearable]="false"
        (change)="getAge(company_age);" [(ngModel)]="company_age"></ng-select>
        <!-- <select (change)="getAge($event);" [(ngModel)]="company_age" class="dropdown-toggle form-control">
          <option *ngFor="let option of options" value={{option}}>{{option}}</option>
        </select> -->
        
      </div>
    </div>
    <div class="text-right" style="width:100% !important; float:left;">
      <div *ngIf="user_bot" class="ash_box text-right mt-2 mb-1">
        <h1 class="ansMob text-right">{{company_age}} years</h1>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="col-12 mb-0" *ngIf="showTip">
    <div class="m-auto blockbg boxclr p-2">
      <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
      <p class="text-center tiphead">JUST AN FYI</p>
      <p class="text-center tipmes">{{questionObj.tip}}</p>
    </div>
  </div>
</div>